export const VALID_3D_FILES_EXTENSIONS = [
  "step",
  "stp",
  "catpart",
  "catproduct",
  "cgr",
  "3dxml",
  "sldasm",
  "sldprt",
];

export const VALID_3D_FILES_ACCEPT: Record<string, string[]> = {
  "application/step": [".step", ".stp"],
  "application/x-catia-part": [".catpart"],
  "application/x-catia-product": [".catproduct"],
  "application/x-catia-cgr": [".cgr"],
  "application/vnd.3dxml": [".3dxml"],
  "application/sldasm": [".sldasm"],
  "application/sldworks": [".sldprt"],
};

export const is3DFile = <T extends { name?: string; url?: string }>(file: T): boolean => {
  return VALID_3D_FILES_EXTENSIONS.some(
    (ext) =>
      file.url?.toLowerCase().endsWith(`.${ext}`) ||
      (!!file.name && file.name.toLowerCase().endsWith(`.${ext}`)),
  );
};
